export const SUPPORTED_LANGUAGES = ['en', 'it', 'es'];
export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGE_STORAGE_KEY = 'app_language';

export const LANGUAGE_OPTIONS = [
    { value: 'en', labelKey: 'language.english' },
    { value: 'it', labelKey: 'language.italian' },
    { value: 'es', labelKey: 'language.spanish' },
];

export const translations = {
    en: {
        language: {
            label: 'Language',
            english: 'English',
            italian: 'Italiano',
            spanish: 'Español',
        },
        common: {
            email: 'Email',
            currency: 'Currency',
            amountWithCurrency: 'Amount ({{currency}})',
            goBack: 'Go back',
            goHome: 'Go Home',
            cancel: 'Cancel',
            processing: 'Processing...',
        },
        footer: {
            terms: 'Terms of Service',
            privacy: 'Privacy Policy',
        },
        bank: {
            accounts: {
                usa: 'USA Bank Account',
                eur: 'EUR Bank Account',
            },
            details: {
                beneficiaryName: 'Beneficiary Name',
                accountNumber: 'Account Number',
                swiftBicCode: 'SWIFT / BIC Code',
                abaRoutingNumber: 'ABA Routing Number',
                iban: 'IBAN',
                currency: 'Currency',
                bankCountry: 'Bank Country',
                bankName: 'Bank Name',
                bankAddress: 'Bank Address',
                important: 'IMPORTANT',
                importantUsd: 'Only for payments in USD.',
                importantEur: 'Only for EUR payments via SEPA.',
            },
        },
        home: {
            selectPaymentAction: 'Select a payment action',
            paymentTypes: {
                manual: 'Online Payment',
                subscription: 'Subscription',
                bankTransfer: 'Bank Transfer',
                authorization: 'Save a Payment method',
                verification: 'Verification transaction',
            },
            verificationNote: 'This is a fixed transaction of 1 EUR / GBP / USD',
            actionButton: {
                authorization: 'Proceed to save a payment method',
                verification: 'Proceed to Pay',
                manual: 'Proceed to Pay',
                subscription: 'Subscribe',
                default: 'Initialize Payment',
            },
            alerts: {
                invalidEmail: 'Please enter a valid email.',
                invalidPaymentType: 'Invalid payment type selected.',
                initError: 'There was an error initializing the payment. Please try again.',
            },
        },
        checkout: {
            actionButton: {
                authorization: 'Save payment method',
                verification: 'Pay',
                manual: 'Pay',
                subscription: 'Subscribe',
                default: 'Initialize Payment',
            },
            bankTransferNoAction: 'Bank transfer selected. No redirection or further action needed.',
        },
        subscription: {
            standardSubscription: 'Standard subscription',
            manualSubscription: 'Manual Subscription',
            selectProduct: 'Select Product',
            selectAProduct: 'Select a product',
            createSubscription: 'Create Subscription',
            billingInterval: 'Billing Interval',
            intervals: {
                day1: 'Daily',
                week1: 'Weekly',
                month1: 'Monthly',
                month2: 'Every 2 months',
                month3: 'Every 3 months',
                month4: 'Every 4 months',
                month6: 'Every 6 months',
                year1: 'Yearly',
            },
            alerts: {
                emailRequired: 'Please enter an email',
                presetRequired: 'Please select a preset product',
                createError: 'There was an error creating the subscription.',
            },
        },
        success: {
            paymentThanks: 'Thanks for the payment!',
            setupDone: 'Setup successfully done!',
        },
        notFound: {
            message: 'Oops! The page you are looking for doesn\'t exist.',
        },
        futurePayment: {
            amountPlaceholder: 'Future Payment Amount',
            startPayment: 'Initiate Future Payment',
        },
    },
    it: {
        language: {
            label: 'Lingua',
            english: 'English',
            italian: 'Italiano',
            spanish: 'Español',
        },
        common: {
            email: 'Email',
            currency: 'Valuta',
            amountWithCurrency: 'Importo ({{currency}})',
            goBack: 'Indietro',
            goHome: 'Torna alla home',
            cancel: 'Annulla',
            processing: 'Elaborazione...',
        },
        footer: {
            terms: 'Termini di servizio',
            privacy: 'Informativa sulla privacy',
        },
        bank: {
            accounts: {
                usa: 'Conto bancario USA',
                eur: 'Conto bancario EUR',
            },
            details: {
                beneficiaryName: 'Nome beneficiario',
                accountNumber: 'Numero conto',
                swiftBicCode: 'Codice SWIFT / BIC',
                abaRoutingNumber: 'Numero ABA routing',
                iban: 'IBAN',
                currency: 'Valuta',
                bankCountry: 'Paese della banca',
                bankName: 'Nome banca',
                bankAddress: 'Indirizzo banca',
                important: 'IMPORTANTE',
                importantUsd: 'Solo per pagamenti in USD.',
                importantEur: 'Solo per pagamenti in EUR tramite SEPA.',
            },
        },
        home: {
            selectPaymentAction: 'Seleziona un\'operazione di pagamento',
            paymentTypes: {
                manual: 'Pagamento online',
                subscription: 'Abbonamento',
                bankTransfer: 'Bonifico bancario',
                authorization: 'Salva un metodo di pagamento',
                verification: 'Transazione di verifica',
            },
            verificationNote: 'Questa e una transazione fissa di 1 EUR / GBP / USD',
            actionButton: {
                authorization: 'Procedi per salvare un metodo di pagamento',
                verification: 'Procedi al pagamento',
                manual: 'Procedi al pagamento',
                subscription: 'Abbonati',
                default: 'Inizializza pagamento',
            },
            alerts: {
                invalidEmail: 'Inserisci un\'email valida.',
                invalidPaymentType: 'Tipo di pagamento non valido.',
                initError: 'Si e verificato un errore durante l\'inizializzazione del pagamento. Riprova.',
            },
        },
        checkout: {
            actionButton: {
                authorization: 'Salva metodo di pagamento',
                verification: 'Paga',
                manual: 'Paga',
                subscription: 'Abbonati',
                default: 'Inizializza pagamento',
            },
            bankTransferNoAction: 'Bonifico selezionato. Nessuna azione aggiuntiva necessaria.',
        },
        subscription: {
            standardSubscription: 'Abbonamento standard',
            manualSubscription: 'Abbonamento manuale',
            selectProduct: 'Seleziona prodotto',
            selectAProduct: 'Seleziona un prodotto',
            createSubscription: 'Crea abbonamento',
            billingInterval: 'Intervallo di fatturazione',
            intervals: {
                day1: 'Giornaliero',
                week1: 'Settimanale',
                month1: 'Mensile',
                month2: 'Ogni 2 mesi',
                month3: 'Ogni 3 mesi',
                month4: 'Ogni 4 mesi',
                month6: 'Ogni 6 mesi',
                year1: 'Annuale',
            },
            alerts: {
                emailRequired: 'Inserisci un\'email',
                presetRequired: 'Seleziona un prodotto preimpostato',
                createError: 'Si e verificato un errore durante la creazione dell\'abbonamento.',
            },
        },
        success: {
            paymentThanks: 'Grazie per il pagamento!',
            setupDone: 'Configurazione completata con successo!',
        },
        notFound: {
            message: 'Oops! La pagina che stai cercando non esiste.',
        },
        futurePayment: {
            amountPlaceholder: 'Importo pagamento futuro',
            startPayment: 'Avvia pagamento futuro',
        },
    },
    es: {
        language: {
            label: 'Idioma',
            english: 'English',
            italian: 'Italiano',
            spanish: 'Español',
        },
        common: {
            email: 'Correo electronico',
            currency: 'Moneda',
            amountWithCurrency: 'Importe ({{currency}})',
            goBack: 'Volver',
            goHome: 'Ir al inicio',
            cancel: 'Cancelar',
            processing: 'Procesando...',
        },
        footer: {
            terms: 'Terminos del servicio',
            privacy: 'Politica de privacidad',
        },
        bank: {
            accounts: {
                usa: 'Cuenta bancaria de EE. UU.',
                eur: 'Cuenta bancaria en EUR',
            },
            details: {
                beneficiaryName: 'Nombre del beneficiario',
                accountNumber: 'Numero de cuenta',
                swiftBicCode: 'Codigo SWIFT / BIC',
                abaRoutingNumber: 'Numero de ruta ABA',
                iban: 'IBAN',
                currency: 'Moneda',
                bankCountry: 'Pais del banco',
                bankName: 'Nombre del banco',
                bankAddress: 'Direccion del banco',
                important: 'IMPORTANTE',
                importantUsd: 'Solo para pagos en USD.',
                importantEur: 'Solo para pagos en EUR mediante SEPA.',
            },
        },
        home: {
            selectPaymentAction: 'Selecciona una accion de pago',
            paymentTypes: {
                manual: 'Pago en linea',
                subscription: 'Suscripcion',
                bankTransfer: 'Transferencia bancaria',
                authorization: 'Guardar un metodo de pago',
                verification: 'Transaccion de verificacion',
            },
            verificationNote: 'Esta es una transaccion fija de 1 EUR / GBP / USD',
            actionButton: {
                authorization: 'Continuar para guardar un metodo de pago',
                verification: 'Continuar para pagar',
                manual: 'Continuar para pagar',
                subscription: 'Suscribirse',
                default: 'Inicializar pago',
            },
            alerts: {
                invalidEmail: 'Introduce un correo electronico valido.',
                invalidPaymentType: 'Tipo de pago no valido.',
                initError: 'Se produjo un error al inicializar el pago. Intentalo de nuevo.',
            },
        },
        checkout: {
            actionButton: {
                authorization: 'Guardar metodo de pago',
                verification: 'Pagar',
                manual: 'Pagar',
                subscription: 'Suscribirse',
                default: 'Inicializar pago',
            },
            bankTransferNoAction: 'Transferencia bancaria seleccionada. No se requiere ninguna accion adicional.',
        },
        subscription: {
            standardSubscription: 'Suscripcion estandar',
            manualSubscription: 'Suscripcion manual',
            selectProduct: 'Seleccionar producto',
            selectAProduct: 'Selecciona un producto',
            createSubscription: 'Crear suscripcion',
            billingInterval: 'Intervalo de facturacion',
            intervals: {
                day1: 'Diario',
                week1: 'Semanal',
                month1: 'Mensual',
                month2: 'Cada 2 meses',
                month3: 'Cada 3 meses',
                month4: 'Cada 4 meses',
                month6: 'Cada 6 meses',
                year1: 'Anual',
            },
            alerts: {
                emailRequired: 'Introduce un correo electronico',
                presetRequired: 'Selecciona un producto predefinido',
                createError: 'Se produjo un error al crear la suscripcion.',
            },
        },
        success: {
            paymentThanks: 'Gracias por el pago!',
            setupDone: 'Configuracion completada con exito!',
        },
        notFound: {
            message: 'Ups! La pagina que buscas no existe.',
        },
        futurePayment: {
            amountPlaceholder: 'Importe de pago futuro',
            startPayment: 'Iniciar pago futuro',
        },
    },
};
